import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import snakeCase from 'lodash/snakeCase';
// decamelizeKeys from humps handles numbers incorrectly, lodash handles them properly:

const inflections: Record<string, string> = {
  lastA1cReading: 'last_a1c_reading',
  twelveMonthAverageA1cReading: 'twelve_month_average_a1c_reading',
  _destroy: '_destroy',
};

const decamelizeDeep = (value: any): any => {
  if (isArray(value)) {
    return value.map(decamelizeDeep);
  } else if (isPlainObject(value)) {
    return decamelizeKeys(value);
  }

  return value;
};

const decamelizeKeys = (fields: { [key: string]: any }, validKeys: string[] = []) => {
  const result: Record<string, any> = {};

  Object.keys(fields).forEach((key) => {
    const newKey = inflections[key] || snakeCase(key);

    if (validKeys.find((validKey) => validKey === newKey) || !validKeys.length) {
      result[newKey] = decamelizeDeep(fields[key]);
    }
  });

  return result;
};

export default decamelizeKeys;
